export class ScatterConfig {
  colors: Array<string>;
  constructor(colors: Array<string>) {
    this.colors = colors || [];
  }
}